import { render } from "./App.vue?vue&type=template&id=4dbdc56c"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=4dbdc56c&lang=less"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"desktope/modules/delivery/fast-delivery-modal/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dbdc56c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dbdc56c', __exports__)) {
    api.reload('4dbdc56c', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=4dbdc56c", () => {
    api.rerender('4dbdc56c', render)
  })

}


export default __exports__